module.exports = __webpack_public_path__ + "img/api-management-apis.4a68e1ab.svg";